import { render, staticRenderFns } from "./End.vue?vue&type=template&id=bcf5273a&scoped=true&"
import script from "./End.vue?vue&type=script&lang=ts&"
export * from "./End.vue?vue&type=script&lang=ts&"
import style0 from "./End.vue?vue&type=style&index=0&id=bcf5273a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf5273a",
  null
  
)

export default component.exports